// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
// This service is to be used by software-side edge-facing services. This is not the phone-data layer.
// For use by internal tooling and automation. These endpoints are NOT to be hit by customers!
export const PhoneNumberService = {
    // LookupNumber performs a carrier lookup. Note: this has a small financial cost to each request, so use sparingly.
    LookupNumber(fn, req) {
        try {
            fm.validateUrlParam(req["phoneNumber"], "phoneNumber");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/number-service/v2/lookup/${req["phoneNumber"]}?${fm.renderURLSearchParams(req, ["phoneNumber"])}`, { method: "GET" });
    },
    // Obtain a phone number from the phone number pool, or purchase under the covers if none are available
    ObtainNumber(fn, req) {
        return fn(`/phone/number-service/v2/obtain`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    PurchaseNewPhoneNumber(fn, req) {
        return fn(`/phone/number-service/v2/purchase`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListAvailableNumbers(fn, req) {
        return fn(`/phone/number-service/v2/available-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListPhoneNumbers(fn, req) {
        return fn(`/phone/number-service/v2/list-numbers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
